import { ConsumerDetails } from '@chargeafter/payment-sdk';
import { AppView, FlipOrigin } from '../constants';
import { ConsumerRowDetails } from './customersTabManager';
import { CartItem, nullableAmountAvailableCredit } from './flowManager';
import { UserProfile } from './userManager';

export interface Context {
  merchantId?: string;
  storeId?: string;
  userEmail?: string;
  view?: AppView;
  applicationId?: string;
  consumer?: ConsumerDetails | ConsumerRowDetails;
  availableCredit?: nullableAmountAvailableCredit;
  confirmationToken?: string;
  merchantOrderId?: string;
  signedApplicationId?: string;
  cart?: CartItem[];
  userProfile?: UserProfile;
  fullStoryLink?: string;
  origin?: FlipOrigin;
}

export const getContext = (): Context | null => {
  const context = sessionStorage.getItem('contextStorage');
  return context && JSON.parse(context);
};

const saveContextInStorage = (context: Context) => {
  sessionStorage.setItem('contextStorage', JSON.stringify(context));
};

export const addToContext = <K extends keyof Context>(
  key: K,
  value: Context[K],
) => {
  const previousContext = sessionStorage.getItem('contextStorage')
    ? getContext()
    : {};
  const updatedContext = {
    ...previousContext,
    [key]: value,
  };
  saveContextInStorage(updatedContext);
};

export const removeFromContext = <K extends keyof Context>(key: K) => {
  const previousContext = sessionStorage.getItem('contextStorage')
    ? getContext()
    : {};

  const { [key]: removeFromContext, ...contextToKeep } = previousContext;
  saveContextInStorage(contextToKeep);
};

export const clearContext = () => {
  sessionStorage.removeItem('contextStorage');
};
export const clearUserFromContext = () => {
  const context = getContext() || {};
  const { userEmail, storeId, merchantId, view, userProfile } = context;
  saveContextInStorage({
    merchantId,
    userEmail,
    storeId,
    view,
    userProfile,
  });
};
